export default {
  readers: [
    'MRMRReaders',
    'MRMRCollaborators',
    'MRMRConsolidation',
    'Admin'
  ],
  collaborators: [
    'MRMRCollaborators',
    'MRMRConsolidation',
    'Admin'
  ],
  consolidation: [
    'MRMRConsolidation',
    'Admin'
  ]
}
